import "venobox/dist/venobox.css";
import VenoBox from "venobox/dist/venobox";
// import { initCF7CustomSelect } from "./cf7-select"; 

function venoboxInit() {
    const venoboxInstance = new VenoBox({
        selector: ".veno-box, .team-popup",
        spinner: "wave",
        onPostOpen: function (item, { container }) { 
            
            
            // Wait for VenoBox to finish injecting the HTML and starting the transition
           

            const venoBoxOverlay = document.querySelector(".vbox-overlay");
            if (venoBoxOverlay) {
                const closePopup = venoBoxOverlay.querySelector(".popup-close");

                if (closePopup) {
                    closePopup.addEventListener("click", function () {
                        venoboxInstance.close();
                    }); 
                }
            }

        },
        onPreOpen: function(item) {
            this.customClass = item.classList.contains('team-popup') ? "team-popup-overlay" : "";
        }
    });
}

export { venoboxInit };